<mat-expansion-panel class="list-item" [expanded]="open">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{getCategoryName(item.recommendationCategoryMullang)}} -> {{itemName(item)}}
    </mat-panel-title>
    <mat-panel-description>
      <div class="item row middle-xs">
        <div class="col-xs-6">
          <span><span [innerHTML]="'$common_issued_by' | translate"></span>: </span>
          <span>{{item?.createdBy?.firstName}} {{item?.createdBy?.lastName}}</span>
        </div>
        <div class="col-xs-6 end-xs">
          <span>{{item.recommendationDate | date: 'shortDate'}}</span>
        </div>
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="row between-xs">
    <div class="col-xs-2">
      <mat-form-field class="form-field form-field-full-width">
        <mat-label [innerHTML]="'$common_priority' | translate"></mat-label>
        <mat-select [formControl]="priorityControl" (onChange)="onEditorChange($event)">
          <mat-option *ngFor="let priority of priorityList" [value]="priority.value">{{priority.label | translate}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-xs-1 end-xs">
      <mat-icon *ngIf="!readOnly" 
                class="rec-delete-btn" 
                (click)="removeRecommendation(item)"
                color="error">delete</mat-icon>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-3" *ngIf="item.imageFileName && !imageFileNameDisplay">
        <img *ngIf="item.imageFileName" [src]="item.imageFileName" [alt]="item.title" class="rec-image" (error)="isImageValid($event)" />
    </div>
    <div [ngClass]="{'col-xs-9' : item.imageFileName && !imageFileNameDisplay, 'col-xs-12' : !item.imageFileName || imageFileNameDisplay}">
      <div class="row">
        <div class="col-xs-8">
        <h5 class="no-margin">{{'$common_recommendation' | translate}}</h5>
        </div>
        <div class="col-xs-4 end-xs">
            <button *ngIf="!isEdited && !readOnly" mat-flat-button color="accent" (click)="recomandationEdit()">{{'$common_edit' | translate}}</button>
        </div>
        </div>
        <span class="meta-desc" *ngIf="isEdited && !readOnly">
            <editor [apiKey]="tinyApiKey"
                    [init]="tinyConfig" 
                    [formControl]="templateTextControl"
                    (onFocusOut)="onEditorChange($event)"
                    (onChange)="onEditorChange($event)"
                    ></editor>
        </span>
        <span class="meta-desc" *ngIf="!isEdited || readOnly">
          <div [innerHTML]="readonlyText"></div>
        </span>
    </div>
  </div>
</mat-expansion-panel>
